import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue'),
    meta: { title: '首页 - 江苏友辰工程装备有限公司' }
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue'),
    meta: { title: '关于我们 - 江苏友辰工程装备有限公司' }
  },
  {
    path: '/products',
    name: 'Products',
    component: () => import('../views/Products.vue'),
    meta: { title: '产品中心 - 江苏友辰工程装备有限公司' }
  },
  {
    path: '/products-list/:id',
    name: 'ProductList',
    component: () => import('../views/ProductList.vue'),
    meta: { title: '产品列表 - 江苏友辰工程装备有限公司' }
  },
  {
    path: '/product-detail/:id',
    name: 'ProductDetail',
    component: () => import('../views/ProductDetail.vue'),
    meta: { title: '产品详情 - 江苏友辰工程装备有限公司' }
  },
  {
    path: '/product-item/:categoryId/:productId',
    name: 'ProductItem',
    component: () => import('../views/ProductItem.vue'),
    meta: { title: '产品详情 - 江苏友辰工程装备有限公司' }
  },
  {
    path: '/cases',
    name: 'Cases',
    component: () => import('../views/Cases.vue'),
    meta: { title: '案例展示 - 江苏友辰工程装备有限公司' }
  },
  {
    path: '/cases/:id',
    name: 'CaseDetail',
    component: () => import('../views/CaseDetail.vue'),
    meta: { title: '案例详情 - 江苏友辰工程装备有限公司' }
  },
  {
    path: '/news',
    name: 'News',
    component: () => import('../views/News.vue'),
    meta: { title: '新闻中心 - 江苏友辰工程装备有限公司' }
  },
  {
    path: '/news/detail/:id',
    name: 'NewsDetail',
    component: () => import('../views/NewsDetail.vue'),
    meta: { title: '新闻详情 - 江苏友辰工程装备有限公司' }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/Contact.vue'),
    meta: { title: '联系我们 - 江苏友辰工程装备有限公司' }
  }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  } else {
    document.title = '江苏友辰工程装备有限公司'
  }
  next()
})

export default router 